import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('adminToken');
      if (!window.location.pathname.startsWith('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const customerApi = axios.create({ baseURL: API, withCredentials: true });

export const money = (n) => `$${(Number(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    const dt = new Date(d);
    return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch { return d; }
};
export const statusPill = (s) => {
  const map = {
    paid: 'pill pill-paid',
    partially_paid: 'pill pill-partial',
    unpaid: 'pill pill-unpaid',
    sent: 'pill pill-sent',
    confirmed: 'pill pill-sent',
    draft: 'pill pill-draft',
    overdue: 'pill pill-overdue',
    cancelled: 'pill pill-draft',
  };
  return map[s] || 'pill pill-draft';
};
export const statusLabel = (s) => ({
  partially_paid: 'Partial',
  paid: 'Paid',
  unpaid: 'Unpaid',
  sent: 'Sent',
  confirmed: 'Confirmed',
  draft: 'Draft',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
}[s] || s);
